import Hero from './components/Hero';
import StickyNav from './components/StickyNav';
import ShiftCard from './components/ShiftCard';
import LifecyclePanel from './components/LifecyclePanel';
import RiskMatrix from './components/RiskMatrix';
import ShiftFramework from './components/ShiftFramework';
import Architecture from './components/Architecture';
import PullQuote from './components/PullQuote';
import Footer from './components/Footer';
import Closing from './components/Closing';
import { shifts } from './data/shifts';
import { lifecycle } from './data/lifecycle';

export default function App() {
  return (
    <main className="relative">
      <StickyNav />
      <Hero />

      <section id="shifts" className="mx-auto max-w-6xl px-6 py-32">
        <h2 className="font-display text-4xl md:text-6xl tracking-tight2 mb-4">
          Eight shifts that change the kind of work.
        </h2>
        <p className="text-ink-dim max-w-2xl text-lg mb-16">
          Not faster versions of the old work. Different work.
        </p>
        <div className="grid md:grid-cols-2 gap-6">
          {shifts.map((s, i) => (
            <ShiftCard key={s.title} shift={s} index={i} />
          ))}
        </div>
      </section>

      <PullQuote>
        Pre-2022 we shipped deterministic code that humans wrote and humans used.
        In May 2026 we ship probabilistic capabilities that agents write, agents call,
        and agents partly operate.
      </PullQuote>

      <section id="lifecycle" className="mx-auto max-w-6xl px-6 py-32">
        <h2 className="font-display text-4xl md:text-6xl tracking-tight2 mb-4">
          Thirteen stages. Rewritten.
        </h2>
        <p className="text-ink-dim max-w-2xl text-lg mb-16">
          The lifecycle is intact. Almost every stage inside it is not.
        </p>
        <div className="flex flex-col gap-8">
          {lifecycle.map((stage, i) => (
            <LifecyclePanel key={stage.id} stage={stage} index={i} />
          ))}
        </div>
      </section>

      <Architecture />
      <RiskMatrix />
      <ShiftFramework />
      <Closing />
      <Footer />
    </main>
  );
}
